/**
 * filters.service.ts
 *
 * Typed API call wrappers for the filters domain.
 * Uses the shared apiClient (Axios instance with JWT interceptor).
 */
import { apiClient } from './apiClient';
import type { ApiResponse } from '@/types/api.types';
import type { FilterOption } from '@/types/filters.types';

export interface SavedFiltersResponse {
  filters: Record<string, string[]>;
}

export function getSavedFilters(
  pageUrl: string,
  viewType = '1',
): Promise<SavedFiltersResponse> {
  return apiClient
    .get<ApiResponse<SavedFiltersResponse>>('/filters/persist', {
      params: { pageUrl, viewType },
    })
    .then((r) => r.data.data);
}

export function saveFilter(params: {
  filterType: string;
  filterValue: string;
  pageUrl: string;
  viewType?: string;
}): Promise<void> {
  return apiClient.post('/filters/persist', {
    filterType: params.filterType,
    filterValue: params.filterValue,
    pageUrl: params.pageUrl,
    viewType: params.viewType ?? '1',
  }).then(() => undefined);
}

export function getFilterOptions(
  types: string[],
): Promise<Record<string, FilterOption[]>> {
  const params: Record<string, string> = {};
  types.forEach((t, i) => {
    params[`types[${i}]`] = t;
  });
  return apiClient
    .get<ApiResponse<Record<string, FilterOption[]>>>('/filters/options', { params })
    .then((r) => r.data.data);
}
